module.exports = __webpack_public_path__ + "img/40-l.75d45963.png";